import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ScopeFieldSchemaChangesRoute } from '../../routing'

export  class ScopeFieldSchemaChangesPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <ScopeFieldSchemaChangesRoute />
          </Fragment>
        )
    }
}
